module.exports = __webpack_public_path__ + "static/media/meetup.40a75877.svg";